module.exports = __webpack_public_path__ + "static/img/technology_ban.7eee7d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology/technology_ban.jpg
// module id = Z5A6
// module chunks = 0